import { render } from "./bookingclinic.vue?vue&type=template&id=48da3197&scoped=true"
import script from "./bookingclinic.vue?vue&type=script&lang=js"
export * from "./bookingclinic.vue?vue&type=script&lang=js"

import "./bookingclinic.vue?vue&type=style&index=0&id=48da3197&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48da3197"]])

export default __exports__